export default __webpack_public_path__ + "static/media/swim-ring.1c39dcd7.png";